// extracted by mini-css-extract-plugin
export var item = "benefits-item-module--item--ig2yw";
export var img = "benefits-item-module--img--qOwEJ";
export var title = "benefits-item-module--title--IFeCt";
export var description = "benefits-item-module--description--62lyB";